<!-- Turn On and Off the Alert Banner -->
<div class="row col-md-12">
	<div class="alert alert-success" role="alert" style="width: 100%; text-align: center;font-weight: bold;">
		<i class="fas fa-bell mr-1"></i> RegScale Acquires GovReady to Deliver Leading NIST OSCAL-Enabled GRC Platform <a href="https://regscale.com/blog/govready" target="_blank" class="btn ml-2" style="background-color: white; color: black;">
		READ MORE
	</a> 
	  </div>
</div> 
<div class="hero-section">
	<!-- Shift Compliance -->
	<shift-compliance></shift-compliance>

	<!-- Regscale Solution -->
	<regscale-solution></regscale-solution>

	<!-- Reduce Risk -->
	<reduce-risk></reduce-risk>

	<!-- Compliance Challenges -->
	<compliance-challenges></compliance-challenges>
</div>

<!-- Discover Difference -->
<discover-difference></discover-difference>

<!-- Testimonials -->
<testimonials></testimonials>

<!-- How Regscale Works -->
<how-regscale-works></how-regscale-works>

<!-- Usage Statistics -->
<stats></stats>

<!-- Ready Set -->
<ready-set></ready-set>